import React, { isValidElement, useCallback, useContext } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import ObserverTextField from '../../../text-field/TextField';
import { getHeader } from '../../utils';
import TableContext from '../../TableContext';
import { Size } from '../../../core/enum';
const ItemTitle = function ItemTitle(props) {
    const { record, provided } = props;
    const { dataSet, tableStore, aggregation } = useContext(TableContext);
    const { columnTitleEditable } = tableStore;
    const editing = record.getState('editing');
    const handleEditBlur = useCallback(() => {
        record.setState('editing', false);
    }, []);
    const handleHeaderChange = useCallback((value) => {
        record.set('title', value);
    }, [record]);
    const title = record.get('title');
    const header = getHeader({
        name: record.get('name'),
        title,
        header: record.get('header'),
        dataSet,
        aggregation,
    });
    const titleEditable = columnTitleEditable && record.get('titleEditable') !== false;
    return (React.createElement(React.Fragment, null, editing && titleEditable ? (React.createElement(ObserverTextField, { onBlur: handleEditBlur, value: isValidElement(header) ? title : header, onChange: handleHeaderChange, autoFocus: true, size: Size.small })) : (React.createElement("span", Object.assign({}, (provided && provided.dragHandleProps), { style: provided ? { cursor: 'move' } : undefined }), toJS(header)))));
};
ItemTitle.displayName = 'ItemTitle';
export default observer(ItemTitle);
